import { View } from "@react-pdf/renderer";
import {

  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeAward } from "lib/redux/types";
import { ResumePDFDescription, TemplateTwelvePDFSection, TemplateTwelvePDFSectionWithSubsections } from "./common";

export const Award = ({
  heading,
  awards,
  themeColor,
  isPDF,
  enableMistakeHighlight = false,
}: {
  heading: string;
  awards: ResumeAward[];
  themeColor: string;
  isPDF: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateTwelvePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {awards.map(({ award, issuer, descriptions }, idx) => (
        <View key={idx} wrap={false}>
          <View
            style={{
              ...styles.flexRowBetween,
              marginTop: spacing["0.5"],
            }}
          >
            <View
              style={{
                ...styles.flexRow,
                gap: spacing["2"],
              }}
            >
              <ResumePDFText themeColor={themeColor} bold={true}>{award}</ResumePDFText>
              <ResumePDFText themeColor={themeColor} >{issuer}</ResumePDFText>
            </View>
          </View>
          <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
            <ResumePDFDescription items={descriptions} themeColor={themeColor} enableMistakeHighlight={enableMistakeHighlight} />
          </View>
        </View>
      ))}
    </TemplateTwelvePDFSectionWithSubsections>
  );
};
